import { render, staticRenderFns } from "./addAnchor.vue?vue&type=template&id=fadd6796"
import script from "./addAnchor.vue?vue&type=script&lang=js"
export * from "./addAnchor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports